import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import { withStyles, makeStyles } from "@material-ui/core";

export const Accordion = withStyles({
  root: {
    margin: "16px 0",
    border: "1px solid var(--grayLv4)",
    borderRadius: "5px",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: "1px solid #BFBFBF",
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "16px 0",
    },
  },

  expanded: {},
})(MuiAccordion);

export const AccordionSummary = withStyles({
  root: {
    backgroundColor: "#F5F5F5",
    borderBottom: "1px solid var(--grayLv4)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },

  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

export const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    // borderBottom: '1px solid var(--grayLv4)',
  },
}))(MuiAccordionDetails);

const useStyles = makeStyles({
  acessibleBox: {
    minWidth: "460px",
    maxWidth: "460px",
    wordWrap: "break-word",
    display: "flex",
    fontSize: 16,
    fontWeight: "bold",
  },
  editBtn: {
    color: "blue",
    backgroundColor: "#F5F5F5",
    padding: 5,
    borderRadius: 5,
    border: "none",
    cursor: "pointer",

    "&:hover": {
      background: "gray",
    },
  },
  deleteBtn: {
    color: "red",
    backgroundColor: "#F5F5F5",
    padding: 5,
    borderRadius: 5,
    border: "none",
    cursor: "pointer",
    "&:hover": {
      background: "gray",
    },
  },
  summaryContainer: {
    width: "100%",
  },
  divSummary: {
    display: "flex",

    // gap: "50px",
  },
  divBottom: {
    display: "flex",
  },
  transaction: {
    display: "flex",
    flexDirection: "column",
    fontSize: "15px",
    width: "130px",
    fontWeight: 700,
    color: "var(--black)",
  },
  bookingDate: {
    display: "flex",
    flexDirection: "column",
    color: "var(--black)",
    fontSize: "15px",
    width: "300px",
  },
  observations: {
    display: "flex",
    fontSize: "15px",
    marginTop: "20px",
  },
  status: {
    fontWeight: 500,
    color: "var(--black)",
    textTransform: "uppercase",
    fontSize: "15px",
    minWidth: "250px",
    maxWidth: "300px",
    textAlign: "right",
  },
  accordionStatus: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  accordionStatusOptions: {
    display: "flex",
  },
  option: {
    color: "#86A1FF",
    fontSize: "14px",
    textDecoration: "underline",
    cursor: "pointer",
    "& :hover": {
      color: "#2f417f",
    },
  },
  withoutIcon: {
    width: 15,
    height: 15,
  },
  boxTitle: {
    fontWeight: 500,
    fontSize: "13px",
  },
  boxContent: {
    fontWeight: 400,
    fontSize: "13px",
  },
  th: {
    textAlign: "left",
  },
  thInitial: {
    textAlign: "left",
    width: "50%",
  },
  td: {
    textAlign: "left",
  },
  reasonContainer: {
    width: "100%",
  },
  block: {
    width: "100%",
    border: "1px solid var(--black)",
    fontSize: 13,
    padding: "12px 14px",
  },
  tableButtons: {
    background: "#ff6500",
    color: "white",
    marginLeft: "5px",
    border: "none",
    borderRadius: "5px",
    padding: "10px",
    cursor: "pointer",
    fontSize: "10px",
    width: "120px",
    fontWeight: 550,
    "&:hover": {
      background: "#a14524",
    },
  },
  tableButtonsDisabled: {
    background: "#e6e6e6",
    color: "white",
    marginLeft: "5px",
    border: "none",
    borderRadius: "5px",
    padding: "10px",
    cursor: "not-allowed",
    fontSize: "10px",
    width: "120px",
    fontWeight: 550,
  },

  copyBtn: {
    width: "26px",
    padding: "2px",
    marginLeft: "8px",
    height: "26px",
    background: "#ff6500",
    color: "white",
    border: "none",
    borderRadius: "4px",
    boxSizing: "border-box",
    cursor: "pointer",
    fontSize: "13px",
    "&:hover": {
      background: "#a14524",
    },
  },
  password: {
    fontWeight: 700,
    color: "rgb(97, 97, 97)",
    display: "flex",
    border: "1px solid gray",
    width: "25px",
    marginLeft: "2px",
    justifyContent: "center",
    borderRadius: 5,
    fontSize: "22px",
    alignItems: "center",
    height: "26px",
    // gap: '1px',
  },
  tagAndSize: {
    display: "flex",
    gap: 30,
  },
  buttons: {
    maxWidth: "140px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    marginLeft: "5px",
  },
  divDetails: {
    display: "flex",
  },
  modulocker: {
    minWidth: "460px",
    maxWidth: "460px",
    wordBreak: "normal",
    // width: '20%',
    fontSize: 16,
  },
  rentedUntil: {
    width: "30%",
    fontSize: 16,
  },
  observationField: {
    width: "200px",
    fontWeight: 700,
    color: "var(--black)",
  },

  "@media only screen and (max-width: 1400px)": {
    divSummary: {
      gap: "40px",
      flexWrap: "wrap",
    },
    divBottom: {
      gap: "40px",
    },
    boxAndSize: {
      gap: "30px",
      marginRight: "20px",
    },
    bookingDate: {
      fontSize: "15px",
    },
    transaction: {
      fontSize: "15px",
    },
  },
  "@media only screen and (min-width: 661px) and (max-width: 800px)": {
    divSummary: {
      gap: "35px",
      flexWrap: "wrap",
    },
    divBottom: {
      flexWrap: "wrap",
      gap: "20px",
      padding: "5px",
      width: "100%",
    },
    boxAndSize: {
      gap: "30px",
      marginRight: "20px",
    },
    bookingDate: {
      fontSize: "13px",
    },
    transaction: {
      fontSize: "13px",
    },
    modulocker: {
      width: "20%",
      fontSize: 13,
    },
    rentedUntil: {
      width: "30%",
      fontSize: 13,
    },
  },
  "@media only screen and (min-width: 350px) and (max-width: 660px)": {
    acessibleBox: {
      minWidth: "300px",
      maxWidth: "300px",
      wordBreak: "normal",
      display: "flex",
      fontWeight: "bold",
      fontSize: 12,
      marginTop: 20,
    },
    summaryContainer: {
      flexDirection: "column",
      marginLeft: "-50px",
    },
    divSummary: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "20px",
      padding: "5px",
      marginLeft: "50px",
    },
    divBottom: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "10px",

      width: "100%",
    },
    transaction: {
      fontSize: "12px",
    },
    bookingDate: {
      flexDirection: "column",
      fontSize: "12px",
      width: "100px",
    },
    status: {
      marginTop: "10px",
      textAlign: "center",
      padding: "5px",
      fontSize: "15px",
      marginLeft: "30px",
      width: "50px",
    },
    boxAndSize: {
      flexDirection: "row",
      gap: "40px",
    },
    password: {
      textAlign: "left",
      marginRight: "-2px",
    },
    observations: {
      fontSize: "12px",
      width: "300px",
    },
    divDetails: {
      display: "flex",
      flexDirection: "column",
    },

    buttons: {
      marginLeft: "-8px",
      marginTop: "10px",
    },
    modulocker: {
      minWidth: 250,
      maxWidth: 250,
      wordBreak: "normal",

      fontSize: "12px",
    },
    rentedUntil: {
      width: "80%",
      fontSize: "12px",
    },
    observationField: {
      width: "80%",
      fontWeight: 700,
      color: "var(--black)",
    },
    tableButtons: {
      marginTop: 10,
    },
  },
});

export default useStyles;
